/**
 * CUSTOM TABLE BODY API CALLS
 *
 * Contains the API call for fetching the table entries.
 *
 * @version 0.1
 */

import xhr from './../../../utils/xhr';
import { GET } from './../../../constants';

let api = {

    getTableData: function(url, pageNumber, pageSize, urlParams, dataStore, verb, requestPayload) {
        if (dataStore!=null) {
                return Promise.resolve({body:dataStore});
        }

        // Add URL parameters
        // url = api.buildUrl(url, pageNumber, pageSize, urlParams);

        if (verb === GET) {
            let queryParams = api.buildQueryParams(pageNumber, pageSize, urlParams);

            return xhr.get({
                url: url,
                data: queryParams
            });
        } else {
            let queryParams = api.splitQueryParams(url);
            let newUrl = api.getRootUrl(url);

            queryParams = urlParams ? Object.assign(queryParams, urlParams) : queryParams;
            queryParams = api.buildQueryParams(pageNumber, pageSize, queryParams);

            return xhr.post({
                url: newUrl,
                queryParams: queryParams,
                data: requestPayload ? requestPayload : null
            });
        }
    },

    buildQueryParams: function(pageNumber, pageSize, urlParams) {
        let parsedUrlParams = Object.assign({}, urlParams);

        return Object.assign(
            {
                pageNumber: pageNumber,
                pageSize: pageSize
            },
            parsedUrlParams
        );
    },
    
    splitQueryParams: function(url) {
        let index = url.indexOf('?');
        if (index < 0) return {};
        let query = url.substr(index + 1),
            queryParts = query.split('&'),
            queryParams = {};

        for (let i = 0; i < queryParts.length; i++) {
            let keyValuePair = queryParts[i].split('=');

            if (keyValuePair.length === 2) {
                queryParams[keyValuePair[0]] = decodeURIComponent(keyValuePair[1]);
            } else {
                queryParams[keyValuePair[0]] = null;
            }
        }

        return queryParams;
    },

    getRootUrl: function(url) {
        if (url.indexOf('?')>0) {
            return url.substr(0, url.indexOf('?') + 1);
        } else {
            return url;
        }
    },
};

export default api;


// WEBPACK FOOTER //
// ./src/scripts/reusable/CustomTableBody/redux/CustomTableBody.api.js